import * as types from '../actions/actionTypes';
import { combineReducers } from 'redux';
import initialState from './initialState';

const banks = (state = initialState.payment.banks, action) => {
	switch (action.type) {
		case types.PAYMENT__GET_BANK_NAME_SUCCESS:
			return { ...state, [action.payload.routingNumber]: action.response };
		default:
			return state;
	}
};

const settings = (state = initialState.payment.settings, action) => {
	switch (action.type) {
		case types.PAYMENT__GET_SETTINGS_REQUEST:
			return { ...state, loading: true, loaded: false };
		case types.PAYMENT__GET_SETTINGS_SUCCESS:
			return { ...state, loading: false, ...action.response, loaded: true };
		case types.PAYMENT__GET_SETTINGS_FAILURE:
			return { ...state, loading: false, loaded: false };
		case types.PAYMENT__GET_WALLETS_REQUEST:
			return { ...state, loading: true, wallets: [], walletsLoaded: false };
		case types.PAYMENT__GET_WALLETS_SUCCESS:
			return { ...state, loading: false, wallets: action.response, walletsLoaded: true };
		case types.PAYMENT__GET_WALLETS_FAILURE:
			return { ...state, loading: false, wallets: [], walletsLoaded: false };
		case types.PAYMENT__UPDATE_WALLET_SUCCESS:
			const wallet = state.wallets.find((w) => `${w.walletId}` === action.payload.walletId);
			wallet.consumerEmail = action.payload.emailAddress;
            const wallets = [...state.wallets]
            const index = wallets.indexOf(wallet)
			wallets[index] = {...wallet}
			return { ...state, wallets }
		default:
			return state;
	}
};

const auth = (state = initialState.payment.auth, action) => {
	switch (action.type) {
		case types.PAYMENT__GET_AUTH_REQUEST:
			return { ...state, loading: true };
		case types.PAYMENT__GET_AUTH_SUCCESS:
			return { ...state, loading: false, ...action.response };
		case types.PAYMENT__GET_AUTH_FAILURE:
			return { ...state, loading: false };
		default:
			return state;
	}
};

const scheduled = (state = initialState.payment.scheduled, action) => {
	switch (action.type) {
		case types.PAYMENT__GET_SCHEDULED_PAYMENTS_REQUEST:
		case types.PAYMENT__GET_SETTINGS_FAILURE:
			return [];
		case types.PAYMENT__GET_SCHEDULED_PAYMENTS_SUCCESS:
			return action.response;
		default:
			return state;
	}
}

const paymentReducer = combineReducers({
	banks,
	settings,
	auth,
	scheduled
});

export default paymentReducer;
